export default __webpack_public_path__ + "static/media/T740_RoHS.4e22f40b.pdf";